/*

Ashraf 12/01/2022 2699242124 fixed page break issue

*/


export const getOptions = (typeCode, dropDownData) => {
  let label = [];
  label = dropDownData && dropDownData[typeCode] ? dropDownData[typeCode] : [];

  return label;
};

export const getOptionsInOrder = (typeCode, dropDownData) => {
  let label = [];
  label =
    dropDownData && dropDownData[typeCode] ?
      [...dropDownData[typeCode]].sort((a, b) =>
        a.valueCode > b.valueCode ? 1 : b.valueCode > a.valueCode ? -1 : 0,
      ) :
      [];

  return label;
};

export const getUDWOptions = (options) => {
  let Options = [];
  Options =
    options &&
    options?.map((option) => {
      return {key: option, value: option};
    });
  return Options;
};
